import { combineReducers } from 'redux';

import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import onboardingReducer from './reducers/onboardingReducer';
import taggableParagraphReducer from './reducers/taggableParagraphReducer';
import masteryReducer from './reducers/masteryReducer';
import hintTrackingReducer from './reducers/hintTrackingReducer';
import saveDataReducer from './reducers/saveDataReducer';

// keeping the reducer collection as a separate exported object enables us
// to do some light test automation on every reducer.
// see ./reducers/__tests__/reducerRejections.test.js
// for more details.
export const reducerCollection = {
  screen: screenReducer,
  roundPlay: roundPlayReducer,
  onboarding: onboardingReducer,
  taggableParagraph: taggableParagraphReducer,
  mastery: masteryReducer,
  hintTracking: hintTrackingReducer,
  saveData: saveDataReducer,
};

const reducers = combineReducers({ ...reducerCollection });

export default reducers;
